import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

import { getPlanDetails } from "../services/api/getAllPlans";

const ProtectedModuleRoute = ({ requiredModule }) => {
  const userInfo = useSelector((state) => state.userLogin?.userInfo);

  const [loading, setLoading] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);

  useEffect(() => {
    const checkAccess = async () => {
      try {
        const planId = userInfo?.currentPlanId;

        if (!planId) {
          setHasAccess(false);
          return;
        }

        const response = await getPlanDetails(planId);

        const planDetails = response?.data?.data || response?.data;

        const modules = planDetails?.modules || [];

        setHasAccess(modules.includes(requiredModule));
      } catch (error) {
        console.error("Failed to check subscription access:", error);
        setHasAccess(false);
      } finally {
        setLoading(false);
      }
    };

    if (!userInfo) {
      setLoading(false);
      return;
    }

    checkAccess();
  }, [userInfo?.currentPlanId, requiredModule]);

  if (loading) {
    return null;
  }

  if (!hasAccess) {
    return <Navigate to='/app/home' replace />;
  }

  return <Outlet />;
};

export default ProtectedModuleRoute;
